
export enum DataLoadingStatusTypes {
  None, Amending, Loading, Retrieved
}
